module.exports = __webpack_public_path__ + "brandon_thin_it-webfont.65fba1e19ad1f2903647.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_thin_it-webfont.woff
// module id = 953
// module chunks = 7